import { createSlice } from "@reduxjs/toolkit";

const { reducer, actions } = createSlice({
    name: "events",
    initialState: {
        events: {},
    },
    reducers: {
        addEvents(state, action) {
            state.events = action.payload;
        },
        deleteEvents(state, _action) {
            state.events = {};
        },
    },
});

export { actions as eventsActions };
export { reducer as eventsReducer };
